import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "use-of-funds-summary-text" }
const _hoisted_2 = { class: "use-of-funds-usage" }
const _hoisted_3 = { class: "use-of-funds-usage-accordion" }
const _hoisted_4 = { tabindex: "0" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "use-of-funds-benefits" }
const _hoisted_8 = { class: "use-of-funds-revenue-comparison" }
const _hoisted_9 = { class: "use-of-funds-revenue-comparison-content flow" }
const _hoisted_10 = { class: "use-of-funds-revenue-comparison-companies flow" }
const _hoisted_11 = { class: "use-of-funds-companies-company" }
const _hoisted_12 = { class: "use-of-funds-companies-graph" }
const _hoisted_13 = { class: "use-of-funds-companies-number" }
const _hoisted_14 = { class: "use-of-funds-companies-link" }
const _hoisted_15 = ["href"]
const _hoisted_16 = { key: 1 }
const _hoisted_17 = ["innerHTML"]

import type { RevenueComparisonItem, UseOfFundsContent } from '@src/components/pages/use_of_funds/UseOfFundsContent';
import BenefitsIcon from '@src/components/pages/use_of_funds/BenefitsIcon.vue';
import { computed } from 'vue';
import CallToAction from '@src/components/pages/use_of_funds/CallToAction.vue';
import ChevronDown from '@src/components/shared/icons/ChevronDown.vue';
import ExternalLink from '@src/components/shared/icons/ExternalLink.vue';
import ContentCard from '@src/components/patterns/ContentCard.vue';

interface Props {
	content: UseOfFundsContent;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'UseOfFunds',
  props: {
    content: {}
  },
  setup(__props: any) {


const props = __props;

const highestBudget = computed( () => props.content.revenueComparison.companies.items.reduce( ( budget: number, company: RevenueComparisonItem ) =>
	Math.max( budget, company.budget ), 0 )
);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ContentCard, { class: "use-of-funds" }, {
    heading: _withCtx(() => [
      _createElementVNode("h1", null, _toDisplayString(__props.content.title), 1)
    ]),
    content: _withCtx(() => [
      _createElementVNode("p", _hoisted_1, _toDisplayString(__props.content.summary), 1),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.content.accordion.items, (accordionItem, index) => {
            return (_openBlock(), _createElementBlock("details", { key: index }, [
              _createElementVNode("summary", _hoisted_4, [
                _createTextVNode(_toDisplayString(accordionItem.title) + " ", 1),
                _createVNode(ChevronDown)
              ]),
              _createElementVNode("div", {
                innerHTML: accordionItem.content
              }, null, 8, _hoisted_5)
            ]))
          }), 128))
        ]),
        _createElementVNode("p", {
          class: "use-of-funds-summary-text",
          innerHTML: __props.content.accordion.summary
        }, null, 8, _hoisted_6)
      ]),
      _createVNode(CallToAction, {
        text: __props.content.callToAction
      }, null, 8, ["text"]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("h2", null, _toDisplayString(__props.content.benefits.title), 1),
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.content.benefits.items, (benefitItem, index) => {
            return (_openBlock(), _createElementBlock("li", { key: index }, [
              _createVNode(BenefitsIcon, {
                icon: benefitItem.icon
              }, null, 8, ["icon"]),
              _createElementVNode("span", null, _toDisplayString(benefitItem.content), 1)
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("h2", null, _toDisplayString(__props.content.revenueComparison.title), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.content.revenueComparison.content, (paragraph, index) => {
            return (_openBlock(), _createElementBlock("p", { key: index }, _toDisplayString(paragraph), 1))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("h3", null, _toDisplayString(__props.content.revenueComparison.companies.title), 1),
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.content.revenueComparison.companies.items, (company) => {
              return (_openBlock(), _createElementBlock("li", {
                key: company.name
              }, [
                _createElementVNode("span", _hoisted_11, _toDisplayString(company.name), 1),
                _createElementVNode("span", _hoisted_12, [
                  _createElementVNode("span", {
                    class: "use-of-funds-companies-budget-line",
                    style: _normalizeStyle({ width: ( company.budget / highestBudget.value * 100 ) + '%' })
                  }, " ", 4)
                ]),
                _createElementVNode("span", _hoisted_13, _toDisplayString(company.budgetString), 1),
                _createElementVNode("span", _hoisted_14, [
                  (company.link !== '')
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        class: "company_budgets__citation_link",
                        href: company.link,
                        target: "_blank"
                      }, [
                        _createTextVNode(_toDisplayString(company.linkText) + " ", 1),
                        _createVNode(ExternalLink)
                      ], 8, _hoisted_15))
                    : (_openBlock(), _createElementBlock("span", _hoisted_16, " "))
                ])
              ]))
            }), 128))
          ])
        ])
      ]),
      _createVNode(CallToAction, {
        text: __props.content.callToAction
      }, null, 8, ["text"]),
      _createElementVNode("p", {
        innerHTML: __props.content.closingParagraph
      }, null, 8, _hoisted_17)
    ]),
    _: 1
  }))
}
}

})